import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['construction-industry'], // 为了获取基础路由
    };
};
export const constructionIndustryToPathNameMap = {
    building5010: () => commonFunc('/'),
};
